//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionLockFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 1C9.24 1 7 3.24 7 6V8H4V22H20V8H17V6C17 3.24 14.76 1 12 1ZM12 17.25C10.76 17.25 9.75 16.24 9.75 15C9.75 13.76 10.76 12.75 12 12.75C13.24 12.75 14.25 13.76 14.25 15C14.25 16.24 13.24 17.25 12 17.25ZM15 8H9V6C9 4.35 10.35 3 12 3C13.65 3 15 4.35 15 6V8Z" fill="currentColor" /></svg>;
}
export default IconActionLockFill;